import { Button } from "@aurora/components";
import { GlyphDownload } from "@aurora/icons";
import React, { useEffect, useRef } from "react";
import { pdfjs } from "react-pdf";

interface PdfViewerProps {
  url: string; // Ссылка на PDF-файл (локально или удаленно)
  scale?: number; // Масштабирование (по умолчанию 1.5)
  candidateId?: string;
}

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

const PdfViewer: React.FC<PdfViewerProps> = ({
  candidateId,
  scale = 1.7,
  url,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  function downloadFile() {
    if (!candidateId) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = `resume_${candidateId}_download`; // имя файла для скачивания (можно задать любое)
    link.dispatchEvent(new MouseEvent("click"));
  }

  useEffect(() => {
    let pdfDoc: pdfjs.PDFDocumentProxy | null = null;

    const renderPdf = async () => {
      try {
        const loadingTask = pdfjs.getDocument(url);
        pdfDoc = await loadingTask.promise;

        if (!containerRef.current) return;
        containerRef.current.innerHTML = "";

        for (let i = 1; i <= pdfDoc.numPages; i++) {
          const pdfPage: pdfjs.PDFPageProxy = await pdfDoc.getPage(i);
          const viewport = pdfPage.getViewport({ scale });

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          if (!context) continue;

          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await pdfPage.render({
            canvasContext: context,
            viewport,
          }).promise;

          containerRef.current.appendChild(canvas);
        }
      } catch (error) {
        console.error("Ошибка при отображении PDF:", error);
      }
    };

    renderPdf();

    return () => {
      pdfDoc?.destroy();
    };
  }, [url, scale]);

  return (
    <>
      {candidateId && (
        <Button
          className={"pb-6"}
          iconLeft={<GlyphDownload />}
          onClick={downloadFile}
          shape="inline"
          variant="primary"
        >
          Скачать файл
        </Button>
      )}
      <div ref={containerRef} className={"pb-6"}></div>
    </>
  );
};

export default PdfViewer;
